module.exports = function (app, mod, invite) {
  var invite_class = invite.target && invite.players[invite.target - 1] == mod.publicKey ? " my-turn" : "";
  var invite_img = "/".concat(invite.game_slug, "/img/arcade/arcade-banner-background.png");
  var html = "\n          <div class=\"saito-module saito-game".concat(invite_class, "\" id=\"saito-game-").concat(invite.game_id, "\" \n      \t\t\t\tstyle=\"background-image: url('").concat(invite_img, "');\">\n        <div class=\"saito-module-titlebar\">\n          <div class=\"saito-module-titlebar-title\">").concat(invite.game_name, "</div>\n          <div class=\"saito-module-titlebar-details game-type\">").concat(invite.game_type.toUpperCase(), "</div>\n        </div>           \n        <div class=\"arcade-invite-actions\">\n          <div class=\"saito-game-details arcade-invite-identicons\">\n    ");

  // render players who have joined
  for (var i = 0; i < invite.players.length; i++) {
    //invite_class = (invite.target && invite.target == i + 1) ? " arcade-invite-turn" : ""; 
    html += "\n          <div class=\"saito-identicon-box\">\n            <img class=\"saito-module-identicon saito-identicon\" id-".concat(invite.players[i], "\" \n            \t\t\t\tsrc=\"").concat(app.keychain.returnIdenticon(invite.players[i]), "\">");
    //    if (invite_class){
    //      html += `<i class="fa-solid fa-circle-exclamation"></i>`;
    //    }
    html += '</div>';
  }

  // render players who are requested to join (their slot isnt empty)
  for (var _i = 0; _i < invite.desired_opponent_publickeys.length; _i++) {
    html += "\n          <div class=\"arcade-invite-requested\">\n            <img class=\"saito-module-identicon saito-identicon\" id-".concat(invite.desired_opponent_publickeys[_i], "\" \n            \t\t\tsrc=\"").concat(app.keychain.returnIdenticon(invite.desired_opponent_publickeys[_i]), "\">\n          </div>\n\n      ");
  }

  // render empty slots; empty slots =  players needed - (players joined + players requested)
  for (var _i2 = 0; _i2 < invite.empty_slots; _i2++) {
    html += "\n          <div class=\"saito-module-identicon arcade-invite-slot\">\n          </div>\n      ";
  }
  html += "\n          </div>\n        </div>";
  if (invite_class) {
    html += "<div class=\"arcade-invite-badge\">your turn</div>";
  }
  // Overwrite "your turn" as necessary
  if (invite.winner) {
    if (invite.winner.includes(mod.publicKey)) {
      html += "<div class=\"arcade-invite-badge\">you won</div>";
    } else {
      html += "<div class=\"arcade-invite-badge\">you lost</div>";
    }
  }
  html += "</div>";
  return html;
};